
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

@Component({
    selector: 'split-payout',
    templateUrl: 'split-payout.html'
})
export class SplitPayout {
    fee: number;
    riderPercentage: number;
    ownerPercentage: number;
    stallionPercentage: number;
    breederPercentage: number;

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.fee = navParams.get('fee');
    }

    create() {
        this.viewController.dismiss({ 
            riderPercentage: this.riderPercentage, 
            ownerPercentage: this.ownerPercentage, 
            stallionPercentage: this.stallionPercentage, 
            breederPercentage: this.breederPercentage});
    }

    cancel() {
        this.viewController.dismiss(null);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/results/split-payout.ts